var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" 경력사항 "), _vm.mode == 'form' ? _c('span', {
    staticClass: "page-text--sm grey-6--text pl-8 font-weight-regular"
  }, [_vm._v("경력 작성시 더 좋은 일자리를 구할 수 있습니다.")]) : _vm._e()]), _c('v-sheet', [_c('v-divider', {
    staticClass: "primary border-2"
  }), _c('vertical-table-row', {
    attrs: {
      "term": "경력구분",
      "required": _vm.mode == 'form'
    }
  }, [_vm.mode == 'form' ? [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-select', _vm._b({
    class: "workExperience-type-".concat(_vm.className),
    attrs: {
      "items": _vm.types,
      "menuProps": {
        attach: ".workExperience-type-".concat(_vm.className)
      }
    },
    on: {
      "change": _vm.onChangeWorkExperienceType
    },
    model: {
      value: _vm.resume.workExperience.type,
      callback: function callback($$v) {
        _vm.$set(_vm.resume.workExperience, "type", $$v);
      },
      expression: "resume.workExperience.type"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _vm.resume.workExperience.type == _vm.WORK_EXPERIENCES.EXPERIENCED.value ? [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": ""
    }
  }, [_c('v-currency-field', _vm._b({
    attrs: {
      "max": 99,
      "suffix": "년"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume.workExperience.span.years,
      callback: function callback($$v) {
        _vm.$set(_vm.resume.workExperience.span, "years", $$v);
      },
      expression: "resume.workExperience.span.years"
    }
  }, 'v-currency-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": ""
    }
  }, [_c('v-currency-field', _vm._b({
    attrs: {
      "max": 11,
      "suffix": "개월"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume.workExperience.span.months,
      callback: function callback($$v) {
        _vm.$set(_vm.resume.workExperience.span, "months", $$v);
      },
      expression: "resume.workExperience.span.months"
    }
  }, 'v-currency-field', _vm.attrs_input, false))], 1)] : _vm._e()], 2)] : [_c('p', {
    staticClass: "page-text grey--text"
  }, [_vm._v(_vm._s(_vm.workExperienceType))])]], 2), _vm._l(_vm.resume.workExperience.list, function (item, index) {
    var _item$duration, _item$duration2, _item$duration3, _item$duration4;
    return [_c('v-divider', {
      key: index,
      staticClass: "primary border-2 mt-12 mt-lg-20"
    }), _c('vertical-table-row', {
      key: "".concat(item.tempId, "-type"),
      attrs: {
        "term": "근무형태"
      }
    }, [_vm.mode == 'form' ? [_c('v-row', {
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', [_c('v-select', _vm._b({
      class: "employmentType-".concat(_vm.className, "-").concat(index),
      attrs: {
        "items": _vm.employmentTypes,
        "menuProps": {
          attach: ".employmentType-".concat(_vm.className, "-").concat(index)
        }
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.type,
        callback: function callback($$v) {
          _vm.$set(item, "type", $$v);
        },
        expression: "item.type"
      }
    }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      staticClass: "v-btn--minus",
      attrs: {
        "icon": "",
        "color": "grey-f8"
      },
      on: {
        "click": function click($event) {
          return _vm.remove(item);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-minus")])], 1)], 1)], 1)] : [_c('p', {
      staticClass: "page-text grey--text"
    }, [_vm._v(_vm._s(_vm.getTypeText(item)))])]], 2), _c('vertical-table-row', {
      key: "".concat(item.tempId, "-companyName"),
      attrs: {
        "term": "회사명"
      }
    }, [_vm.mode == 'form' ? [_c('v-row', {
      attrs: {
        "no-gutters": "",
        "align": "center"
      }
    }, [_c('v-col', [_c('v-text-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.companyName,
        callback: function callback($$v) {
          _vm.$set(item, "companyName", $$v);
        },
        expression: "item.companyName"
      }
    }, 'v-text-field', _vm.attrs_input, false))], 1)], 1)] : [_c('p', {
      staticClass: "page-text grey--text"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.companyName))])]], 2), _c('vertical-table-row', {
      key: "".concat(item.tempId, "-duration"),
      attrs: {
        "term": "근무기간"
      }
    }, [_vm.mode == 'form' ? [_c('v-row', {
      staticClass: "row--small",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', [_c('v-text-field', _vm._b({
      attrs: {
        "type": "date",
        "max": "2999-12-31",
        "label": "시작일"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.duration.startsAt,
        callback: function callback($$v) {
          _vm.$set(item.duration, "startsAt", $$v);
        },
        expression: "item.duration.startsAt"
      }
    }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
      staticClass: "px-10",
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v(" ~ ")]), _c('v-col', [_c('v-text-field', _vm._b({
      attrs: {
        "type": "date",
        "max": "2999-12-31",
        "label": "종료일"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.duration.endsAt,
        callback: function callback($$v) {
          _vm.$set(item.duration, "endsAt", $$v);
        },
        expression: "item.duration.endsAt"
      }
    }, 'v-text-field', _vm.attrs_input, false))], 1)], 1)] : item !== null && item !== void 0 && (_item$duration = item.duration) !== null && _item$duration !== void 0 && _item$duration.startsAt || item !== null && item !== void 0 && (_item$duration2 = item.duration) !== null && _item$duration2 !== void 0 && _item$duration2.endsAt ? [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$duration3 = item.duration) === null || _item$duration3 === void 0 ? void 0 : _item$duration3.startsAt) + " ~ " + _vm._s(item === null || item === void 0 ? void 0 : (_item$duration4 = item.duration) === null || _item$duration4 === void 0 ? void 0 : _item$duration4.endsAt) + " ")] : _vm._e()], 2), _c('vertical-table-row', {
      key: "".concat(item.tempId, "-description"),
      attrs: {
        "term": "담당업무"
      }
    }, [_vm.mode == 'form' ? [_c('v-textarea', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.description,
        callback: function callback($$v) {
          _vm.$set(item, "description", $$v);
        },
        expression: "item.description"
      }
    }, 'v-textarea', _vm.attrs_input, false))] : [_c('p', {
      staticClass: "page-text grey--text"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.description))])]], 2)];
  })], 2), _vm.mode == 'form' ? [_c('v-btn', {
    staticClass: "v-btn--plus rounded-lg",
    attrs: {
      "block": "",
      "color": "grey-f8"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('i', {
    staticClass: "icon icon-plus-sm"
  })])] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }